
import { useEffect, useState } from "react";
import axios from "axios";
import Router, { useRouter } from "next/router";
import { Link } from "react-daisyui";
import { Alert, Button, Checkbox, Label, TextInput } from "flowbite-react";
import ApiHelper from "@/shared/ApiHelper";
import toastCustom from "@/shared/toastCustom";
import utils from "@/shared/utils";
import analytics from "@/lib/analytics";

import CelularInput from "@/components/maks/CelularInput";
import { toast } from "react-toastify";
import InputSenha from "@/components/Forms/InputSenha";
import RegrasSenha from "@/components/Forms/RegrasSenha";

import { GoogleReCaptcha, useGoogleReCaptcha } from "react-google-recaptcha-v3";


interface IProps {
  searchParam?: { [key: string]: string | string[] | undefined };
  providers?: any;
  tipo?: string;
  rota?: string;
  backgroundImage?: string;
  clientIp?: any;
  isPageADM?: boolean;
  alterarTipo?: (parametro: string) => void; 
}

export default function FormUsuario({
  tipo,
  searchParam,
  rota,
  backgroundImage,
  clientIp,
  isPageADM,
  alterarTipo
}: IProps) {

  const router = useRouter();
  const [error, setError] = useState("");

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [celular, setCelular] = useState("");
  const [password, setPassword] = useState("");
  const [confirm_password, setConfirmPassword] = useState("");
  const [spinner, setSpinner] = useState(false);
  const [termos, setTermos] = useState(false);

  const [isValidRecaptcha, setValidRecaptcha] = useState(true)

  const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();

  useEffect(() => {
    getApiRecaptcha()
  }, []);

  const getApiRecaptcha = async (token?: string) => {
    
    // Token real do reCAPTCHA v3 (vem do <GoogleReCaptcha onVerify>)
    
    if (!token) return null;
  
    try {
      const res = await ApiHelper.post({
        method: "POST",
        url: ApiHelper.recaptcha,
        data: { recaptchaToken: token },
      });
        
      if (res.response === true) {
        setValidRecaptcha(true);
        setRefreshReCaptcha(false)
      }

      return res;

    } catch (error) {
      setValidRecaptcha(false);
      setRefreshReCaptcha(true)
    }

    return null;
  };

  const handleRecaptchaChange = async (value: any) => {
    await getApiRecaptcha(value)
  };

  const registerUser = async () => {
    if (!isPageADM && !termos) {
      setError("É necessário aceitar os termos para criar a conta.");
      return;
    }


    // const resp = await getApiRecaptcha()
    // if (resp === null) {
    //     toastCustom.show({
    //         mensagem: 'É necessário responder aos desafios do recaptcha. Reinicie a página!',
    //         type: 'warning'
    //     })
    //     return
    // }

    const uSplit = username.split(" ");

    if (uSplit.length == 1 || (uSplit.length > 1 && uSplit[1] == "")) {
      setError("Digite o nome completo.");
      return;
    }

    if (uSplit[0].length < 2 || uSplit[1].length < 2) {
      setError("Digite o nome completo.");
      return;
    }

    if (
      email == "" ||
      celular == "" ||
      username == "" ||
      password == "" ||
      confirm_password == ""
    ) {
      setError("Todos os campos devem ser preenchidos.");
      return;
    }

    if (!utils.validarEmail(email)) {
      setError("Digite um email válido.");
      return;
    }

    const numeroCelular = utils.somenteNumeros(celular) ?? "";

    if (numeroCelular.length !== 11) {
      setError("Digite o celular completo com DDD.");
      return;
    }

    if (!utils.validarDDD(numeroCelular.substring(0, 2))) {
      setError("O DDD informado não é válido.");
      return;
    }

    if (!utils.validarCelular(numeroCelular)) {
      setError("Digite um número de celular válido.");
      return;
    }

    if (password != confirm_password) {
      setError("Os campos de Senha e Confirmar Senha devem ser iguais.");
      return;
    }

    if (password.length < 8) {
      setError("A senha deve conter 8 caracteres ou mais.");
      return;
    }

    setSpinner(true);

    const idToast = toast.loading("Salvando...")

    // reCAPTCHA v3 (transparente): o backend confere antes de criar a conta
    const recaptchaToken = executeRecaptcha
      ? await executeRecaptcha("cadastro").catch(() => "")
      : "";

    const res = await axios
      .post(
        "/api/register",
        { username, email: email.trim(), celular, password, termos, ativo: false },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "x-recaptcha-token": recaptchaToken,
          },
        }
      )
      .then(async () => {
        // Component FormUsuario usados nas páginas de cadastro de usuario e página ADM
        // isPageADM usado para identificar se a página é ADM e evita o toast após o cadastro
        if (isPageADM) {
          toast.update(idToast, { render: "Usuário adicionado com sucesso", type: "success", isLoading: false, autoClose: 3000 });
        }

        setSpinner(false);

        // cadastro feito pelo próprio usuário (não conta o feito pelo ADM)
        if (!isPageADM) {
          await analytics.cadastro();
        }
       
        toast.update(idToast, { render: "Um link de confirmação foi enviado no seu e-mail. Confirme o e-mail para ter acesso a sua conta!", type: "success", isLoading: false, autoClose: 10000 });
        redirectToHome();
      })
      .catch((error) => {
        setSpinner(false);
        const split = error.response.data.error.split(":");
        setError(split.length > 1 ? split[1] : split[0]);
      });
  };

  const redirectToHome = () => {
    // Component FormUsuario usados nas páginas de cadastro de usuario e página ADM
    // isPageADM usado para identificar se a página é ADM e evita o login após o cadastro
    if (isPageADM) return

    const { pathname } = Router;

    if (pathname === "/auth/[tipo]") {
      if (rota == "cart") {
        window.location.href = "/checkout/cart";
      } else {
        if (alterarTipo) {
          alterarTipo('Login')
        }
       router.push('/auth/login');
      }
    } else {
      console.log("nada");
    }
  };

  const onChangeCheckBox = (e: {
    target: { checked: boolean; value: React.SetStateAction<string> };
  }) => {
    setTermos(() => e.target.checked);
  };

  const formSubmit = async (event: any) => {
    event.preventDefault();

    setError("");
    registerUser();
  };

  return (
    <>
      <form
        onSubmit={formSubmit}
        className={isPageADM ? "md:p-10 p-5 pt-16 rounded-sm space-y-5 bg-white" : "space-y-5"}
      >
        {error != "" && (
          <>
            <div>
              <Alert color="failure">
                <span>
                  <span className="font-bold">Atenção!</span>
                  {" " + error}
                </span>
              </Alert>
            </div>
          </>
        )}

        <div className="">
          <div className="space-y-4">
            <div>
              <div className="mb-2 block">
                <Label htmlFor="nome" value="Nome completo" />
              </div>
              <TextInput
                id="nome"
                type="text"
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Digite seu nome completo"
                required={true}
                autoFocus={true}
              />
            </div>
            <div>
              <div className="mb-2 block">
                <Label htmlFor="email" value="Email" />
              </div>
              <TextInput
                id="email"
                type="text"
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu@email.com"
                required={true}
              />
            </div>
            <div>
              <CelularInput
                placeholder="(00) 00000-0000"
                label="Celular"
                onChange={(e: any) => setCelular(e.target.value)}
                value={celular}
              />
            </div>
            <div>
              <InputSenha
                id="password"
                label="Senha"
                value={password}
                onChange={setPassword}
                placeholder="Digite uma senha segura"
                autoComplete="new-password"
              />
              {!isPageADM && password != "" && <RegrasSenha senha={password} />}
            </div>
            <div>
              <InputSenha
                id="confirm_password"
                label="Confirmar senha"
                value={confirm_password}
                onChange={setConfirmPassword}
                placeholder="Digite a senha novamente"
                autoComplete="new-password"
              />
              {confirm_password != "" && password != confirm_password && (
                <p className="mt-1 text-xs text-red-600">As senhas não são iguais.</p>
              )}
            </div>
            <div className="">
              <div className="flex items-center mt-4 gap-3">
                <Checkbox
                  checked={termos}
                  id="termos"
                  onChange={onChangeCheckBox}
                />
                <Label className="text-xs">
                  Aceito a{" "}
                  <Link href="/auth/politica" className="text-blue-700">
                    Política de Privacidade
                  </Link>
                  ,{" "}
                  <Link
                    href="/auth/regras-meia-entrada"
                    className="text-blue-700"
                  >
                    Regras de Meia Entrada
                  </Link>{" "}
                  e os{" "}
                  <Link href="/auth/termos" className="text-blue-700">
                    Termos e Condições Gerais de Uso.
                  </Link>
                </Label>
              </div>
            </div>
            <div className="pt-4">
              <Button color="failure" type="submit" className="w-full" disabled={!isPageADM && !termos}>
                {spinner ? "AGUARDE.." : "CADASTRAR"}
              </Button>
              {isValidRecaptcha === false && (
                <GoogleReCaptcha onVerify={handleRecaptchaChange} refreshReCaptcha={refreshReCaptcha} />
              )}
            </div>
          </div>
        </div>
                       
      </form>
    </>

  );
}

